module.exports = __webpack_public_path__ + "img/sipa.1ff62e49.png";